module.exports = __webpack_public_path__ + "img/program2.f811d880.png";